import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { auth as authApi } from '../lib/api';
export const useAuthStore = create()(persist((set) => ({
    token: null,
    user: null,
    isAuthenticated: false,
    login: async (email, password) => {
        const res = await authApi.login(email, password);
        const { token, user } = res.data;
        localStorage.setItem('earnpos_token', token);
        set({ token, user, isAuthenticated: true });
    },
    logout: async () => {
        try {
            await authApi.logout();
        }
        catch { }
        localStorage.removeItem('earnpos_token');
        set({ token: null, user: null, isAuthenticated: false });
        window.location.href = '/login';
    },
    loadMe: async () => {
        const res = await authApi.me();
        set({ user: res.data, isAuthenticated: true });
    },
}), { name: 'earnpos-auth', partialize: (s) => ({ token: s.token }) }));
